import { GetS3CredentialsRequest } from "./../proto/api_pb";
import { useCallback, useEffect, useState } from "react";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import useGetValidAccessToken from "./useGetValidAccessToken";
import { S3CredentialsContextInterface } from "../contexts";

export const useS3Credentials = (
  userId?: string
): {
  s3Credentials: S3CredentialsContextInterface | undefined;
} => {
  const [s3Credentials, setS3Credentials] =
    useState<S3CredentialsContextInterface>();
  const { getValidAccessToken } = useGetValidAccessToken();
  const getS3UploadCredentials = useCallback(async () => {
    try {
      if (userId) {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetS3CredentialsRequest();
        const token = await getValidAccessToken();
        const metadata = {
          Authorization: `${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        ommuseClient.getS3Credentials(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log(err);
            } else {
              setS3Credentials({
                awsAccessKeyId: response.getAwsAccessKeyId(),
                awsSecretAccessKey: response.getAwsSecretAccessKey(),
                awsSessionToken: response.getSessionToken(),
                expiry: response.getExpiry(),
              });
            }
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
  }, [userId, getValidAccessToken]);

  useEffect(() => {
    const checkS3CredentialExpiry = () => {
      const currentDate = new Date().getTime() / 1000;
      if (!s3Credentials) {
        getS3UploadCredentials();
      } else if (
        s3Credentials.expiry &&
        s3Credentials.expiry - 60 * 5 < currentDate
      ) {
        console.log("refreshing s3 credentials");
        getS3UploadCredentials();
      }
    };
    checkS3CredentialExpiry();
    const intervalId = setInterval(checkS3CredentialExpiry, 1000 * 60);
    return () => {
      clearInterval(intervalId);
    };
  }, [getS3UploadCredentials, s3Credentials]);

  return { s3Credentials: s3Credentials };
};
